import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DetailedTermsOfService() {
  const { t } = useTranslation();

  return (
    <section className="max-w-[1280px] w-full mx-auto mt-[58px] py-[50px]">
      <main>
        <h1 className="font-bold text-MainTextColor text-5xl mb-14">
          {t('서비스 이용약관')}
        </h1>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제1조(목적)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          이 약관은 크릿 스튜디오(이하 '회사'라 합니다)가 운영하는 CREAIT 마인크래프트 리소스 스토어(이하 '스토어'라 합니다)에서 제공하는 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제2조(정의)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          이 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.
        </p>
        <ol className="list-decimal font-medium text-[#515151] text-lg mb-6 pl-7">
          <li className="my-3">
            ‘서비스’란 회사가 제공하는 CREAIT 스토어의 모든 온라인 서비스를 의미합니다.
          </li>
          <li className="my-3">
            ‘이용자’란 서비스에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.
          </li>
          <li className="my-3">
            ‘회원’은 회사에 개인정보를 제공하여 회원 등록을 한 개인 또는 기업을 의미하며, 판매자 및 구매자를 포함합니다.
          </li>
          <li className="my-3">
            ‘비회원’은 회원가입 없이 서비스를 이용하는 자를 말합니다.
          </li>
          <li className="my-3">
            ‘아이디(ID)’란 회원 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인한 문자와 숫자의 조합을 의미합니다.
          </li>
          <li className="my-3">
            ‘비밀번호’란 아이디와 일치성을 확인하고 비밀 보호를 위해 회원 자신이 정한 문자와 숫자의 조합을 의미합니다.
          </li>
          <li className="my-3">
            ‘유료서비스’란 회사가 유료로 제공하는 각종 온라인 디지털 콘텐츠 및 제반 서비스를 의미합니다.
          </li>
          <li className="my-3">
            ‘콘텐츠’란 정보통신망을 통해 제공되는 디지털 형태의 글, 사진, 동영상, 파일 등을 의미합니다.
          </li>
          <li className="my-3">
            ‘스토어’란 회원이 콘텐츠를 업로드하고 판매하거나, 구매할 수 있는 온라인 플랫폼을 의미합니다.
          </li>
          <li className="my-3">
            ‘크리에이터’란 스토어에 콘텐츠를 업로드하고 판매하는 회원을 의미합니다.
          </li>
          <li className="my-3">
            ‘구매자’란 스토어에서 콘텐츠를 구매하는 회원을 의미합니다.
          </li>
        </ol>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제3조(약관의 명시와 개정)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회사는 이 약관의 내용을 회원이 알 수 있도록 서비스 초기 화면에 게시합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 회사는 약관의 규제에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 서비스 초기 화면에 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정인 경우에는 최소 30일 이상의 사전 유예기간을 두고 공지합니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제4조(개인정보 처리 방침)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          회사는 개인정보 보호법 등 관련 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보 처리 방침이 적용됩니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제5조(회원 가입 및 판매자 등록)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 이용자는 회사가 정한 가입 양식에 따라 회원 정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원 가입을 신청합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 회원이 스토어에서 판매 활동을 하기 위해서는 별도의 판매자 등록 절차를 완료해야 합니다. 판매자 등록 시 크리에이터 정보, 결제 정보를 제공하고, 관련 약관에 동의해야 합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 회사는 회원의 가입 및 판매자 등록 신청에 대하여 승낙함을 원칙으로 합니다. 다만, 아래 각 호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 회원 자격을 제한 또는 정지할 수 있습니다.
        </p>
        <ol className="list-decimal font-medium text-[#515151] text-lg mb-6 pl-7">
          <li className="my-3">가입 신청자가 이 약관에 의하여 이전에 회원 자격을 상실한 적이 있는 경우</li>
          <li className="my-3">실명이 아니거나 타인의 명의를 이용한 경우</li>
          <li className="my-3">허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
          <li className="my-3">기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
        </ol>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제6조(콘텐츠 가격 책정)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 크리에이터는 자신이 업로드한 콘텐츠의 판매 가격을 직접 결정할 수 있습니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 크리에이터는 콘텐츠의 품질과 시장 가치를 고려하여 적정한 가격을 책정해야 합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 할인 및 프로모션 설정은 회사의 정책에 따라 진행할 수 있습니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제7조(구매 및 다운로드)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회원은 스토어에서 원하는 콘텐츠를 선택하여 결제한 후 즉시 다운로드 또는 사용 권한을 얻을 수 있습니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 결제 수단은 신용카드, 전자지갑 등 회사가 지정한 방법을 통해 가능합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 환불 요청은 회사의 환불 정책에 따라 처리되며, 다운로드 후에는 제한될 수 있습니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제8조(수수료 정책)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회사는 콘텐츠 판매에 대해 판매 금액의 10%를 수수료로 부과합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 활동이 우수한 크리에이터를 위해 수수료 단계 감소 제도를 운영하며, 판매 실적 및 콘텐츠 품질 평가 기준을 충족할 경우 수수료가 감소됩니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. ‘크릿 작업자’ 등급을 획득하면 수수료가 최대 5%까지 감소됩니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제9조(크리에이터 등급 시스템)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회사는 크리에이터의 성장을 지원하기 위해 등급 시스템을 운영합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 등급은 일반 크리에이터, 상위 크리에이터, 크릿 작업자로 구분되며, 판매 실적과 작품 품질에 따라 자동으로 승급됩니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 크릿 작업자 승급 시 회사의 심사를 거치며, 추가 혜택이 주어집니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제10조(저작권 및 규제 준수)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 크리에이터는 저작권법 및 마인크래프트 사용자 정책을 준수해야 합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 불법 복제나 타인의 권리를 침해하는 콘텐츠는 업로드가 금지되며, 적발 시 제재가 이루어질 수 있습니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 회사는 모든 콘텐츠에 대해 등록 전 검토 절차를 진행하며, 부적합한 콘텐츠는 반려될 수 있습니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제11조(환불 정책)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 디지털 상품의 특성상 구매 후 환불은 제한되며, 다음의 예외적인 경우에만 환불이 가능합니다:
        </p>
        <ol className="list-decimal font-medium text-[#515151] text-lg mb-6 pl-7">
          <li className="my-3">
            파일에 치명적인 결함이 있는 경우: 콘텐츠에 명백한 오류가 있거나 파일이 손상된 경우
          </li>
          <li className="my-3">
            잘못된 결제 또는 중복 결제: 실수로 동일한 콘텐츠를 여러 번 결제한 경우
          </li>
        </ol>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 다음의 경우에는 환불이 불가능합니다:
        </p>
        <ol className="list-decimal font-medium text-[#515151] text-lg mb-6 pl-7">
          <li className="my-3">콘텐츠가 정상적으로 다운로드 및 사용된 경우</li>
          <li className="my-3">단순 변심으로 인한 환불 요청</li>
          <li className="my-3">사용자의 기술적 요구 사항 미충족으로 인한 문제</li>
          <li className="my-3">이용 가이드를 숙지하지 않아 발생한 문제</li>
        </ol>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          3. 환불 절차는 고객 지원팀에 이메일로 접수해야 하며, 필요한 정보를 정확히 제공해야 합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          4. 환불 요청은 접수 후 3-5 영업일 이내에 처리되며, 승인된 경우 원 결제 수단으로 환불됩니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제12조(서비스 제공기간)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 구매자는 결제일로부터 12개월 동안 콘텐츠를 다운로드 및 사용할 수 있는 권한을 가집니다. 이 기간 동안 다운로드를 하지 않은 경우, 12개월 이후에는 접근 권한이 제한될 수 있습니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 구매 후 다운로드된 콘텐츠는 서비스 제공기간과 상관없이 영구적으로 사용할 수 있습니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제13조(커뮤니티 소통 및 지원)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회사는 디스코드 및 다양한 커뮤니티 채널을 통해 회원 간의 소통을 지원합니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 커뮤니티에서는 스토어 관련 질문, 창작물 피드백, 이벤트 안내 등이 제공됩니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제14조(문의 및 지원 안내)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          서비스 이용 중 궁금한 사항이나 문제가 발생한 경우, 아래의 고객 지원팀으로 문의하시기 바랍니다.
        </p>
        <ul className="list-disc font-medium text-[#515151] text-lg mb-6 pl-7">
          <li className="my-3">이메일: korea@cnitsstore.com</li>
        </ul>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제15조(면책 조항)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.
        </p>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          2. 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
        </p>

        <h2 className="font-bold text-MainTextColor text-3xl mb-8">제16조(준거법 및 재판관할)</h2>
        <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
          이 약관은 대한민국 법령에 의하여 규정되고 이행되며, 서비스 이용과 관련하여 회사와 회원 간에 발생한 분쟁에 대해서는 민사소송법상의 관할 법원에 제소합니다.
        </p>
      </main>
    </section>
  );
}
